module.exports = __webpack_public_path__ + "img/avatar-gender-m-s.70590fc6.png";